import { metricCategory } from '@pulse/metrics';
import useTemplateMetrics from './useTemplateMetrics';

function useMetricCategory(params) {
  const { templateMetricCategory } = useTemplateMetrics(params);
  const res = { ...metricCategory };
  // add template metric category for App
  const appCategory = metricCategory.APP ?? {};
  templateMetricCategory.forEach(
    (category) => (appCategory[category] = category)
  );
  res.APP = appCategory;
  return res;
}

export default useMetricCategory;
